import ProjectCard from "../../components/project-card/ProjectCard"
import {useStProjectsContext} from "../../reactContext/contextCustomHooks/useStProjectsContext"

export default function StProjectsContent({projects}) {
    const {stProjectsContext} = useStProjectsContext()
    return (
        <>
        <div className="SECTION ST-PROJECTS-CONTENT">
            {projects.map((project, index) => (
                <ProjectCard key={`st-project-card-${index}`} project={project} type={"st"} tab={stProjectsContext.tab}/>
            ))}
        </div>
        </>
    )
}